// External library (like npm libs)
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import { featuredTestimonials } from "./modules/featuredTestimonials";
import { AT } from "./modules/announcement";
import { CBLB } from "./modules/columnBlockListBackground";
import { H } from "./modules/header";
import { GM } from "./modules/geolocatedMap";
import { S } from "./modules/search";
import { BP } from "./modules/blogPage";
import { N } from "./modules/newsletter";
import { HB } from "./modules/homeBanner";
import { forms } from "./modules/forms";
import { MM } from "./modules/mobileMenu";
import { GLM } from "./modules/galleryLoadMore";
import { GJ } from "./modules/galleryJustify";
import { ELF } from "./modules/elfsight";

(() => {
    
    document.addEventListener("DOMContentLoaded", function () {
        window.addEventListener("load", function () {
            window.requestAnimationFrame(async function () {

                const { CookiesConsent } = await import("./modules/cookiesConsent");
                const { gLightbox } = await import("./modules/glightbox");
                
                AT.init();
                CookiesConsent.init();
                featuredTestimonials.init();
                gLightbox.init();
                CBLB.init();
                HB.init();
                H.init();
                S.init();
                GM.init();
                N.init();
                BP.init();
                forms.initFile();
                MM.init();
                GLM.init();
                GJ.init();
                ELF.init();
            });
        });
    });
})();